import { Button } from "@/components/ui/button";
import { Save, RotateCcw, CheckCircle2, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

interface SaveBarProps {
  distributionTotal: number;
  isSaving: boolean;
  onReset: () => void;
  onSave: () => void;
}

export function SaveBar({ distributionTotal, isSaving, onReset, onSave }: SaveBarProps) {
  return (
    <div className="sticky bottom-0 -ml-[30px] -mr-[25px] z-40 bg-card px-6 py-3 flex items-center justify-between gap-4 shadow-[0_-4px_12px_-2px_rgba(0,0,0,0.08)]">
      <div className="flex items-baseline gap-6">
        <div className="flex items-baseline gap-2">
          <span className="text-sm text-foreground">Total</span>
          <span className="text-2xl font-bold tabular-nums text-foreground">{distributionTotal}</span>
          <span className="text-sm text-muted-foreground">/ 100%</span>
        </div>
        <div className={cn(
          "flex items-baseline gap-1.5 text-sm",
          distributionTotal === 100 ? "text-foreground" : "text-status-warning-strong"
        )}>
          {distributionTotal === 100 ? (
            <>
              <CheckCircle2 className="h-4 w-4 text-status-success-strong self-center" />
              <span>Weights are balanced. Ready to save.</span>
            </>
          ) : (
            <>
              <AlertTriangle className="h-4 w-4 text-status-warning-strong self-center" />
              <span>{distributionTotal < 100
                ? `Allocate ${100 - distributionTotal}% more to reach 100%.`
                : `Reduce weights by ${distributionTotal - 100}% to reach 100%.`}</span>
            </>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" className="h-9 rounded-lg bg-card" onClick={onReset}>
          <RotateCcw className="h-3.5 w-3.5 mr-1.5" />
          Reset to Default
        </Button>
        <Button size="sm" className="h-9 rounded-lg" onClick={onSave} disabled={distributionTotal !== 100 || isSaving}>
          <Save className="h-3.5 w-3.5 mr-1.5" />
          Save Configuration
        </Button>
      </div>
    </div>
  );
}
